import React from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { RemoveCircle } from "@mui/icons-material";
const ImageUpload = ({ image, index, handleFileChange, removeImageInput }) => {
  return (
    <Box
      sx={{
        width: 120,
        height: 120,
        border: "1px solid #ccc",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        overflow: "hidden",
        position: "relative", // Required for positioning the index
      }}
    >
      {/* Index Badge */}
      {/* Index Badge */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: "7%",
          margin: "2px",
          transform: "translateX(-50%)",
          backgroundColor: "black",
          color: "white",
          width: 16,
          height: 16,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "10px",
          borderRadius: "50%",
        }}
      >
        {index + 1}
      </Box>
      {index >= 4 && (
        <Box
          sx={{
            position: "absolute",
            top: 2,
            right: 2,
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            onClick={() => removeImageInput(index)}
            sx={{
              padding: 0,
              width: 16,
              height: 16,
            }}
          >
            <RemoveCircle color="error" sx={{ fontSize: 16 }} />
          </IconButton>
        </Box>
      )}
      {/* Image Preview */}
      <Box
        sx={{
          width: "120px",
          height: "85px",
          marginTop: "3px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f9f9f9",
        }}
      >
        {image && image !== "" ? (
          <img
            src={image}
            alt="Preview"
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        ) : (
          <Typography variant="caption" sx={{ textAlign: "center" }}>
            No Image
          </Typography>
        )}
      </Box>

      {/* Hidden File Input */}
      <input
        type="file"
        accept=".jpg"
        style={{ display: "none" }}
        id={`image-upload-${index}`}
        onChange={(e) => handleFileChange(e, index, "images")}
      />

      {/* Browse Button */}
      <label htmlFor={`image-upload-${index}`} style={{ width: "100%" }}>
        <Button
          component="span"
          fullWidth
          variant="contained"
          size="small"
          sx={{ borderTop: "1px solid #ccc", textTransform: "none" }}
        >
          Browse
        </Button>
      </label>
    </Box>
  );
};

export default ImageUpload;
